import * as React from 'react';
import {createView, view} from '@sail/ui';

import {styles} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterDisclaimerBrazil/SiteFooterDisclaimerBrazilStyles';

/**
 * Renders small legal text meant for the site footer
 */
export const SiteFooterDisclaimerBrazil = createView((props) => {
  return (
    <view.div {...props} uses={[styles.container]}>
      <view.div uses={[styles.content]}>
        {/**
         * The only existing footer disclaimer is for Brazil
         */}
        <view.ul
          uses={[styles.disclaimerList, styles.disclaimerListUnprocessed]}
        >
          <view.li>
            Stripe Brasil Soluções de Pagamento Ltda. - Instituição de Pagamento
          </view.li>
          <view.li>Tax ID (CNPJ): 22.121.209/0001-46</view.li>
          <view.li>
            Stripe Brasil Soluções de Pagamento Ltda - Payment Institution is a
            payment institution that operates as an acquirer.
          </view.li>
        </view.ul>
      </view.div>
    </view.div>
  );
});
